import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { ProjectService } from '../../../api/services/project.services';
import { Bom } from '../../../api/models/bom';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from '../../delete-modal/delete-modal.component';
import { Organization } from '../../../api/models/organization';
import { Market, MarketsInput } from '../../../api/models/market-model';
import { UserService } from '../../../api/services/user.service';
import { MarketService } from '../../../api/services/market.service';
import { AuthService } from '../../../api/services/auth.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { User } from '../../../api/models/user-model';
import { PaginatedRequest } from '../../../api/models/paginated-request';
import { RoleRequest } from '../../../api/models/role-assignment-map';

@Component({
  selector: 'app-bom-edit',
  templateUrl: './bom-edit.component.html',
  styleUrls: ['./bom-edit.component.scss']
})
export class BomEditComponent implements OnInit {

  @Input() inBom: Bom;
  @Input() backToSearch: string;

  @Output() leaveEdit = new EventEmitter<any>();

  masterBomData: Observable<any[]>;
  private data: any[] = [];

  name : string;
  notes: string;
  bom: Bom;
  editing = false;
  nullName = false;

  organizations: Organization[] = [];
  allMarkets: Market[] = [];
  marketsFiltered: Market[] = [];
  selectedOrgId = '';

  loading: boolean = false;

  marketDropdownSettings;
  filteredMarketsForDropdown: Market[] = [];
  selectedMarkets = [];
  selectedAccountNumbers = [];
  roleRequest: RoleRequest;
  isTesscoAdmin: any;
  loadBomTableDetails: boolean = false;
  disableDeleteButton : boolean = true;
  disableSaveButton : boolean = true;
  marketsInput: MarketsInput;
  filterMarketSearchTerm: string;
  dropDownOpen: boolean = false;
  sorting: string = 'customerName,name';
  disableOrgId: boolean = false;
  isClientAdmin: boolean = false;
  isCreatedByTesscoAdmin: boolean = false;

  constructor(
    private toastr: ToastrService,
    private projectService: ProjectService,
    private modalService: NgbModal,
    private userService: UserService,
    private marketService: MarketService,
    private authService: AuthService
  ) { }

  createBom(name: string) {
    this.name = name;
  }

  deleteBom(bom: Bom) {
    let selectedMarketIds = [];
    this.selectedMarkets.forEach(sm => selectedMarketIds.push(sm.id));

    const modalRef = this.modalService.open(DeleteModalComponent, {
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the Bom <strong>${bom.name}</strong> ?`;
    modalRef.componentInstance.fn = () => {
      this.projectService.deleteBom(bom.id, selectedMarketIds).subscribe(data => {
        modalRef.close();
        this.leaveEdit.emit();
        this.onSuccess('BOM deleted sucessfully!!!');
      }, error => {
       modalRef.close();
        this.leaveEdit.emit();
        this.onFailure('BOM could not be deleted. Please ensure that you are having permission.!!!');
      });
    };
  }

  goBack() {
    this.leaveEdit.emit();
  }

  onRowsChange(data: any[]) {
    this.data = data;
    this.onUpdateSuccess();
  }

  private onUpdateSuccess() {
    this.toastr.success('BOM saved!!!', 'Succcess!', {
      timeOut: 1000,
      positionClass: 'toast-bottom-right'
    });
  }

  changeOrg(organizationId: string) {
    this.selectedOrgId = organizationId;
    this.selectedMarkets = [];
    this.fetchMarket();
  }

  ngOnInit() {
    this.bom = this.inBom;
    if (this.inBom.id) {
      this.name = this.bom.name;
      this.masterBomData = this.projectService.getBomLines(this.inBom.id);
      this.isBomCreatedByTesscoAdmin(this.bom.createdBy,'ADMIN_TESSCO');
      this.disableOrgId = true;
      this.loadBomTableDetails = true;
    }else{
      this.disableOrgId = false;
      this.loadBomTableDetails = false;
    }
    this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
    this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', null);
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
      this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
      this.isClientAdmin = roles.getRoleMap('ADMIN_CLIENT');


      forkJoin(this.userService.findUserById(this.authService.getUserId()), this.userService.getOrganizations())
        .subscribe((data: [User, Organization[]]) => {

          this.organizations = data[1];
          let user = data[0];
          if (this.inBom.id) {
            if(user['Team ID']) {
              // setting flags for Initiator and approver
              this.authService.getTeamById(user['Team ID']).subscribe(team => {
                if (team.type === 0 || team.type === 1) {
                  if (data[0]['User ID'] == this.bom.createdBy) {
                    this.editing = true;
                    this.disableSaveButton = false;
                    this.disableDeleteButton = false;
                  }
                }
              });
            } else if(this.isClientAdmin && !this.isCreatedByTesscoAdmin) {
              //setting flags for Client Admin
                this.editing = true;
                this.disableSaveButton = false;
                this.disableDeleteButton = false;

            } else if(this.isTesscoAdmin) {
              // setting flags for Tessco Admin
                this.editing = true;
                this.disableSaveButton = false;
                this.disableDeleteButton = false;
            }
          }else {
              this.editing = true;
              this.disableSaveButton = false;
              this.disableDeleteButton = false;
            }
          let currentOrgId = user['Organization ID'];
          if (this.editing && this.isTesscoAdmin) {
            currentOrgId = this.bom.id ? this.bom.organizationId : currentOrgId;
          }
          this.selectedOrgId = currentOrgId;
          this.fetchMarket();
      });
    });
    this.setMarketDropdownSettings();
  }

  setMarketDropdownSettings(){
    this.marketDropdownSettings = {
      singleSelection: false,
      textField: 'name',
      itemsShowLimit: 999, //Setting max number
      enableCheckAll: true,
      idField: 'id',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      clearSearchFilter: true
    }
  }

  public isBomCreatedByTesscoAdmin (userId: string, roleName: string){
    this.authService.checkSpecificRoleForUser(userId, roleName).subscribe(result => {
      if(result!=null && result == 'true'){
        //console.log("Admin Tessco")
        this.isCreatedByTesscoAdmin = true;
      }else{
        this.isCreatedByTesscoAdmin = false;
      }
    });
  }

  saveOrUpdateBOM() {
    this.loading = true;
    this.disableSaveButton = true;

    let selectedMarketIds = [];
    this.selectedMarkets.forEach(sm => selectedMarketIds.push(sm.id));

    if (!this.editing) {
        let bomName = this.name;
        this.projectService
           .updateBOMMarkets(bomName, "MasterBom", selectedMarketIds, this.selectedOrgId, null, this.notes)
            .subscribe(data => {
            this.onSuccess('BOM created sucessfully!!!!!');
            this.fetchMarket(true);
            this.bom = data;
            this.inBom = data;
            this.editing = true;
            this.loading = false;
            this.disableSaveButton = false;
            this.disableOrgId = true;
            this.loadBomTableDetails = true;
            }, error => {
             this.onFailure(error.error.message);
             this.loading = false;
             this.disableSaveButton = false;
            });
    } else {
        let bomID = this.inBom.id;
        console.log(this.notes);
        this.projectService
                .updateBOMMarkets(this.name, "MasterBom", selectedMarketIds, this.selectedOrgId, bomID, this.notes)
                .subscribe((data) => {
                this.bom = data;
                this.inBom = data;
                this.onSuccess('BOM updated successfully!!!!!');
                this.fetchMarket(true);
                this.loading = false;
                this.disableSaveButton = false;
                this.disableOrgId = true;
                this.loadBomTableDetails = true;
            }, error => {
              const errorMessage = error.error.message != null ?
                                  error.error.message :"BOM updation failed!!!!";
                this.onFailure(errorMessage);
                this.loading = false;
                this.disableSaveButton = false;
            });
    }
  }

  private onSuccess(successsMessage) {
      this.toastr.success(successsMessage, 'OK!', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right'
      });
   }

  private onFailure(failureMessage) {
      this.toastr.error(failureMessage, 'Error!', {
          timeOut: 5000,
          positionClass: 'toast-bottom-right'
      });
   }

  disableBomSaveButton() {
    if (this.selectedMarkets && this.selectedMarkets.length > 0 && this.name) {
      return false;
    }
    return true;
   }

  searchMarket(item: any) {
    this.filterMarketSearchTerm = item;
    this.dropDownOpen = true;
    this.fetchMarket();
  }

  dropDownClose(item: any) {
    this.filterMarketSearchTerm = item;
    if (this.selectedOrgId && this.dropDownOpen) {
      this.dropDownOpen = false;
      this.fetchMarket(false);
    }
  }

  fetchMarket(modifySelectedMarket: boolean = true) {
    this.marketsInput = new MarketsInput();
    this.marketsInput.orgId = this.selectedOrgId;
    this.marketsInput.marketIds = this.userService.getMarketPermittedForCurrentUser();
    this.marketsInput.searchTerm = this.filterMarketSearchTerm;
    let page: number = 0, pageSize: number = 2000;
    const paginatedRequest = new PaginatedRequest(page, pageSize, this.sorting);
    this.marketService.getMarketsListMinimalInfo(paginatedRequest, this.marketsInput).subscribe(mkts => {
      this.marketsFiltered = mkts.records;
      if (this.inBom.id) {
        this.selectedAccountNumbers = [];
        this.filteredMarketsForDropdown = [];
        this.bom.markets.forEach(marketId => {
          this.marketsFiltered.forEach(market => {
            if(market.id === marketId){
              this.selectedAccountNumbers.push(market.accountNumber);
              this.filteredMarketsForDropdown.push(market);
            }
          });
        });
        console.log("selectedAccountNumbers",this.selectedAccountNumbers)
      }
      if (modifySelectedMarket && this.filteredMarketsForDropdown && this.filteredMarketsForDropdown.length > 0) {
        this.selectedMarkets = this.filteredMarketsForDropdown;
      }
    });
  }

  assignNotes(notes: string) {
    this.notes = notes;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/boms/bom-edit/bom-edit.component.ts